import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import appSlice from "./slices/appSlice";
import departmentsJobTitlesSlice from "./slices/departmentsJobTitlesSlice";
import announcementSlice from "./slices/announcementSlice";
import holidaysSlice from "./slices/holidaysSlice";
import employeeSlice from "./slices/employeeSlice";
import notificationSlice from "./slices/notificationSlice";
import flexibilitySlice from "./slices/flexibilitySlice";
import authSlice from "./slices/authSlice";
import profileSlice from "./slices/profileSlice";
import leaveSlice from "./slices/leaveSlice";
import attendanceSlice from "./slices/attendanceSlice";
import rolesSlice from "./slices/rolesSlice";
import reportsSlice from "./slices/reportsSlice";
import statisticsSlice from "./slices/statisticsSlice";
import shiftsSlice from "./slices/shiftsSlice";
import companyTreeSlice from "./slices/companyTreeSlice";
import bonusesCutsSlice from "./slices/bonusesCutsSlice";
import advancePayments from "./slices/advancePayments";
import salarySlice from "./slices/salarySlice";
import manageSalarySlice from "./slices/manageSalarySlice";
import settingsSlice from "./slices/settingsSlice";
import employeeRatingsSlice from "./slices/employeeRatingsSlice";
import teamLeader from "./slices/teamleaderSlice";
import bonusesOverTimeSlice from "./slices/bonusesOverTimeSlice";

export const store = configureStore({
  reducer: {
    app: appSlice,
    departmentsJobTitles: departmentsJobTitlesSlice,
    announcements: announcementSlice,
    holidays: holidaysSlice,
    employee: employeeSlice,
    notification: notificationSlice,
    flexibility: flexibilitySlice,
    auth: authSlice,
    profile: profileSlice,
    leave: leaveSlice,
    attendance: attendanceSlice,
    roles: rolesSlice,
    reports: reportsSlice,
    statistics: statisticsSlice,
    shifts: shiftsSlice,
    companyTree: companyTreeSlice,
    bonusesCuts: bonusesCutsSlice,
    advancePayments: advancePayments,
    salary: salarySlice,
    manageSalary: manageSalarySlice,
    settings: settingsSlice,
    employeeRatings: employeeRatingsSlice,
    teamLeader: teamLeader,
    bonusesOverTime: bonusesOverTimeSlice,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

setupListeners(store.dispatch);
